import colors, { getRandomColor, polosGeradoresColor } from '../util/colors';
import { MarkerClusterer } from '@googlemaps/markerclusterer';

export default class ClusterService {

    async getClusters(cidades, estados) {
        try {
            const response = await axios.post(route('web.clusters_por_nome_cidade.index'), {
                cidades: cidades,
                estados: estados
            });

            return response.data;

        } catch (error) {
            console.error('Error fetching clusters:', error);
            throw error;
        }
    }

    /**
  * Cria um cluster simples para empreendimentos
  */
    static createEmpreendimentosCluster(map, markers) {
        return new MarkerClusterer({
            markers,
            map,
        });
    }

    static createPolosGeradoresCluster(map, markersByCategory) {
        const clusters = {};

        Object.keys(markersByCategory).forEach(category => {
            clusters[category] = new MarkerClusterer({
                markers: markersByCategory[category],
                map,
                renderer: {
                    render: ({ count, position, markers }) => {
                        const maxCount = 100;
                        const intensity = Math.min(count / maxCount, 1);

                        const main_category = markers[0].main_category;
                        const baseColor = polosGeradoresColor[main_category] || [0, 123, 255];
                        const color = `rgba(${baseColor[0]}, ${baseColor[1]}, ${baseColor[2]}, ${0.4 + intensity * 0.6})`;

                        const svg = `
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
                                <circle cx="20" cy="20" r="18" fill="${color}" />
                            </svg>
                        `;

                        return new google.maps.Marker({
                            position,
                            icon: {
                                url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
                                scaledSize: new google.maps.Size(60, 60),
                            },
                            label: {
                                text: String(count),
                                color: "white",
                                fontSize: "12px",
                                fontWeight: "bold",
                            },
                            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count
                        });
                    }
                }
            });
        });

        return clusters;
    }

    static removeLegenda() {
        document.querySelector('#legenda-gradiente-polos')?.remove();
    }


    static addLegenda(map, polosGeradoresColor, markersByCategory) {
        this.removeLegenda();

        const legenda = document.createElement('div');
        legenda.id = "legenda-gradiente-polos"
        legenda.style.backgroundColor = 'white';
        legenda.style.padding = '10px';
        legenda.style.fontSize = '12px';
        legenda.style.lineHeight = '1.5';
        legenda.style.boxShadow = '0 2px 6px rgba(0,0,0,0.3)';
        legenda.style.maxHeight = '500px';
        legenda.style.overflowY = 'auto';
        legenda.style.minWidth = '210px';

        Object.keys(markersByCategory)
            .sort((a, b) => a.localeCompare(b, 'pt-BR', { sensitivity: 'base' }))
            .forEach(category => {
                const baseColor = polosGeradoresColor[category];
                if (!baseColor) return;

                const rgba = (opacity) => `rgba(${baseColor[0]}, ${baseColor[1]}, ${baseColor[2]}, ${opacity})`;

                legenda.innerHTML += `
            <div style="margin-bottom:8px;">
                <strong>${category}:</strong><br>
                <span style="background: linear-gradient(to right, ${rgba(0.4)}, ${rgba(1)}); display:inline-block; width:180px; height:10px; border-radius:5px;"></span>
                <div style="display:flex; gap:50px; margin-top:5px;">
                    <span style="background:${rgba(0.4)}; border-radius:50%; width:25px; height:25px; display:flex; align-items:center; justify-content:center; color:white;font-size: 10px;">5</span>
                    <span style="background:${rgba(0.7)}; border-radius:50%; width:25px; height:25px; display:flex; align-items:center; justify-content:center; color:white;font-size: 10px;">50</span>
                    <span style="background:${rgba(1)}; border-radius:50%; width:25px; height:25px; display:flex; align-items:center; justify-content:center; color:white;font-size: 10px;">100+</span>
                </div>
            </div>
        `;
            });

        map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(legenda);
    }

    static updateLegendaPosition(sidebarVisible) {
        const legenda = document.getElementById('legenda-gradiente-polos');
        if (!legenda) return;

        const leftValue = sidebarVisible
            ? (window.innerWidth > 1366 ? '22%' : '32%')
            : '0';
        if (!sidebarVisible) {
            legenda.classList.add('legenda-fixada');
        } else {
            legenda.classList.remove('legenda-fixada');
        }
        legenda.style.setProperty('left', leftValue, 'important');
    }


}
